/* @flow */

import * as React from 'react';
import classNames from 'classnames';

// Styles
import styles from './Label.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

const useStyles = createUseThemeStyles(styles);

type Props = {
  className?: string,
  children?: React.Node,
};

const Label = ({ className, children, ...props }: Props) => {
  const classes = useStyles();

  return (
    <label {...props} className={classNames(classes.root, className)}>
      {children}
    </label>
  );
};

export default Label;
